(function() {
  define('bazemont/gallery/picture',['angular'], function() {
    'use strict';
    return angular.module('bazemontGalleryPicture', []).component('bazemontGalleryPicture', {
      templateUrl: '/assets/javascripts/bazemont/gallery/picture.html',
      bindings: {
        picture: '=',
        first: '<',
        last: '<',
        nbColumns: '<',
        hasPreview: '<'
      },
      require: {
        bazemontGalleryPicturesCtrl: '^^bazemontGalleryPictures'
      },
      controller: [
        'TlhConfirmModalService', 'TlhGridClassService', function(TlhConfirmModalService, TlhGridClassService) {
          var vm;
          vm = this;
          vm.columnClass = TlhGridClassService.getColumnClass(vm.nbColumns);
          vm.setPreviewPicture = function() {
            if (!vm.picture.isPreviewPicture) {
              return vm.bazemontGalleryPicturesCtrl.setPreviewPicture(vm.picture);
            }
          };
          vm.moveUp = function() {
            return vm.bazemontGalleryPicturesCtrl.movePictureUp(vm.picture);
          };
          vm.moveDown = function() {
            return vm.bazemontGalleryPicturesCtrl.movePictureDown(vm.picture);
          };
          vm.trash = function() {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer cette photo ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                vm.picture.isActive = false;
                if (vm.picture.isPreviewPicture) {
                  return vm.bazemontGalleryPicturesCtrl.setPreviewPicture();
                }
              }
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=picture.js.map
;
